import React from 'react';
import { cn } from '../../utils/cn';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  href?: string;
}
export function Button({
  className,
  variant = 'primary',
  size = 'md',
  href,
  children,
  ...props
}: ButtonProps) {
  const base = ['inline-flex items-center justify-center', 'font-semibold uppercase tracking-wider', 'transition-all duration-200', 'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-teal focus-visible:ring-offset-2 focus-visible:ring-offset-brand-black', 'active:scale-[0.97] active:transition-none', 'disabled:opacity-40 disabled:cursor-not-allowed disabled:pointer-events-none', 'clip-edges'].join(' ');
  const variants = {
    primary: 'bg-brand-teal text-brand-white border border-transparent hover:bg-brand-teal-light',
    outline: 'bg-transparent text-brand-teal border border-brand-teal hover:bg-brand-teal hover:text-brand-white',
    ghost: 'bg-transparent text-brand-white border border-transparent hover:text-brand-teal hover:bg-brand-gray-900'
  };
  const sizes = {
    sm: 'px-4 py-2 text-xs gap-1.5',
    md: 'px-6 py-3 text-sm gap-2',
    lg: 'px-8 py-4 text-base gap-2.5'
  };
  const classes = cn(base, variants[variant], sizes[size], className);
  if (href) {
    return <a href={href} className={classes} data-id="element-76">
        {children}
      </a>;
  }
  return <button className={classes} {...props} data-id="element-77">
      {children}
    </button>;
}